module.exports = __webpack_public_path__ + "img/teams-adduser-empty-img.18d1b305.svg";